(() => {
  'use strict';

  const LIMIT = 24;
  let scheduled = false;

  const isSoldOut = (card) => {
    const text = (card.textContent || '').replace(/\s+/g, ' ').trim();
    if (/\bsold out\b/i.test(text)) return true;

    return Array.from(card.querySelectorAll('.badge, [class*="badge"], [class*="sold"]'))
      .some((el) => /\bsold out\b/i.test((el.textContent || '').trim()));
  };

  const apply = () => {
    scheduled = false;

    const list = document.querySelector(
      '.shopify-section--main-collection product-list, .shopify-section--main-collection .product-list'
    );
    if (!list) return;

    const items = Array.from(list.querySelectorAll(':scope > .phf-card'));
    if (!items.length) return;

    let kept = 0;

    items.forEach((item) => {
      const card = item.querySelector('.product-card');

      if (!card || isSoldOut(card) || kept >= LIMIT) {
        item.remove();
        return;
      }

      kept += 1;
    });

    document.querySelectorAll(
      '.shopify-section--main-collection .collection-toolbar, .shopify-section--main-collection facets-drawer, .shopify-section--main-collection .facets-sidebar, .shopify-section--main-collection .pagination'
    ).forEach((el) => {
      el.hidden = true;
    });

    list.setAttribute('data-phf-best-sellers-count', String(kept));
    list.setAttribute('aria-label', `Top ${kept} in-stock best sellers`);
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(apply);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);

  const observer = new MutationObserver((records) => {
    const hasRelevantAddition = records.some((record) =>
      Array.from(record.addedNodes).some((node) =>
        node.nodeType === 1 &&
        (node.matches?.('.phf-card, .product-card, product-list') ||
          node.querySelector?.('.phf-card, .product-card'))
      )
    );

    if (hasRelevantAddition) schedule();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
